<template lang="pug">
.mt-4
  v-tabs(v-model='tab')
    v-tab(v-for='item in tabs' :key='item')
      | {{ item }}
  v-tabs-items(v-model='tab')
    v-tab-item(key='Overview')
      Overview(:docs='userCase.documents')
    v-tab-item(key='Company')
      CoverLetter
    v-tab-item(key='Case')
      CoverLetter
    v-tab-item(key='Documents')
      CoverLetter
    v-tab-item(key='Cover letter')
      CoverLetter
</template>

<script>
import Overview from '@/components/Lawyer/Sponsorship/Overview/index'
import CoverLetter from '@/components/Lawyer/Sponsorship/CoverLetter/index'

export default {
  components: { Overview, CoverLetter },
  data() {
    return {
      tabs: ["Overview", "Company","Case","Documents","Cover letter", "HO Application"],
      tab: "Overview",
      userCase: {
        documents: []
      }
    }
  },
  mounted() {
    this.axios.get("/lawyer/case/" + this.$route.params.case_id).then(resp => {
      this.userCase = resp.data
    })
  }
}
</script>